import { createContext, useContext } from "react";

export const FoodContext = createContext();

export function useFood() {
    return useContext(FoodContext);
}
